// Tried installing @types/chrome, but ts-loader needed to be upgraded,
// but then that required upgrading webpack.
declare global {
  interface Window {
    chrome: any;
  }
  const browser: any;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function sendMessage<T>(browser: any, extensionId: string, payload: any): Promise<T> {
  return new Promise((resolve, reject) => {
    try {
      browser.runtime.sendMessage(
        extensionId,
        payload,
        (response:any) => {
          if (browser.runtime.lastError) {
            reject(browser.runtime.lastError);
          }
          resolve(response);
        },
      );
    } catch (error: any) {
      reject(error);
    }
  });
}

// eslint-disable-next-line max-len, @typescript-eslint/explicit-module-boundary-types
export function sendMessageToChromeExtension<T>(extensionId: string, payload: any): Promise<T> {
  return sendMessage(window.chrome, extensionId, payload);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function sendMessageToSafariExtension<T>(extensionId: string, payload: any): Promise<T> {
  return sendMessage(browser, extensionId, payload);
}
